import { isEqual } from 'lodash';

// always returns true because chartDoc.saved always null
function updateDirty(chartDoc) {
  localStorage.setItem('saved', 'false');
  return chartDoc.set('dirty', !isEqual(chartDoc.chart, chartDoc.saved));
}

export default updateDirty;
